exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-23b895da] table > tbody > tr > td {\n\tcursor: pointer;\n}\n", ""]);

// exports
